/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import { loadStripe } from "@stripe/stripe-js";
export const isProductionEnvironment = process.env.REACT_APP_environment === "PROD";
let developConfig: any = {
	app_url: "https://testmyaccount.gutenbergcerts.com",
	ipapi_key: "de9b51bbabda42",
	api_url: "https://qa.gutenbergcerts.com/api/",
	api_version: "v1.2",
	home_path: "https://qa.gutenbergcerts.com/",
	http_authorization: "bhGqy6S9tfe@G%wb",
	title: "develop",
	aws_project_region: "ca-central-1",
	aws_cognito_identity_pool_id: "ca-central-1:7f3f407c-4272-44fb-856f-d83b2d4108cb",
	aws_cognito_region: "ca-central-1",
	aws_user_pools_id: "ca-central-1_9W9uidyIp",
	aws_user_pools_web_client_id: "7in9ri7qjl7637p0n1odg0lmn0",
	oauth: {
		domain: "gutenbergcerts-dev.auth.ca-central-1.amazoncognito.com",
		scope: ["email", "openid", "aws.cognito.signin.user.admin"],
		redirectSignIn: "https://myaccount-uat.gutenbergcerts.com/login",
		redirectSignOut: "https://myaccount-uat.gutenbergcerts.com/login",
		responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
	},
	aws_cloud_logic_custom: [
		{
			name: "AdminQueries",
			endpoint: "https://t2eo6so2we.execute-api.ca-central-1.amazonaws.com/dev",
			region: "ca-central-1",
		},
	],
	stripe_publishable_key: "pk_test_51GJlx9Ax69KuAXazk8SYtWvX0JH09iBEDZZWi3GAP7ow2jfqg0j5F3g2vInDZprjobR7xjpTXjlzklYFrQFDiMeV00rHSzaVak",
	issuer_app_url: "http://uat.gutenbergcerts.com",
};

let productionConfig: any = {
	app_url: "https://myaccount.gutenbergcerts.com",
	ipapi_key: "de9b51bbabda42",
	api_url: "https://issuer222.gutenbergcerts.com/api/",
	api_version: "v1.2",
	home_path: "https://issuer222.gutenbergcerts.com/",
	http_authorization: "ahGqy4S9tfe@G%wc",
	title: "production",
	aws_project_region: "ca-central-1",
	aws_cognito_identity_pool_id: "ca-central-1:9c08189c-8620-481d-8913-295b3e23c637",
	aws_cognito_region: "ca-central-1",
	aws_user_pools_id: "ca-central-1_XQ3PabRTa",
	aws_user_pools_web_client_id: "4e3te43prj5n60fc10e51o41u9",
	oauth: {
		domain: "gutenbergcerts.auth.ca-central-1.amazoncognito.com",
		scope: ["email", "openid", "aws.cognito.signin.user.admin", "profile"],
		redirectSignIn: "https://myaccount.gutenbergcerts.com",
		redirectSignOut: "https://myaccount.gutenbergcerts.com",
		responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
	},
	aws_cloud_logic_custom: [
		{
			name: "AdminQueries",
			endpoint: "https://c8uafkqo4d.execute-api.ca-central-1.amazonaws.com/prod",
			region: "ca-central-1",
		},
	],
	stripe_publishable_key: "pk_live_51GJlx9Ax69KuAXazHD08R6BPropcysd7pHhBUOHQUURoIS07L1tkGTOEpR8hBBroqYw38TchIdXP29XLkKMG4MLx00p17ZrAIl",
	issuer_app_url: "http://app.gutenbergcerts.com",
};

export const getConfig = () => {
	console.log("ENV: ", process.env.REACT_APP_environment);
	if (process.env.REACT_APP_environment === "UAT") {
		return developConfig;
	} else if (process.env.REACT_APP_environment === "PROD") {
		return productionConfig;
	} else {
		return productionConfig;
	}
};

export default getConfig;
